import Auth from '@/pages/Auth';
import { FullLoading } from '@components/Loaders';
import { createLazyFileRoute } from '@tanstack/react-router';
import React from 'react';

export const Route = createLazyFileRoute('/auth/')({
  component: () => <Auth />,
  pendingComponent: () => <FullLoading label="Loading Authentication Settings..." />,
});
